import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store } from './store';
import HTTPSredirect from "react-https-redirect";
import "./ws";

ReactDOM.render(
  <React.StrictMode>
    <HTTPSredirect>
      <Provider store={store}>
        <App />
      </Provider>
    </HTTPSredirect>
  </React.StrictMode>,
  document.getElementById("root")
);
